import { Container, Row, Col, Image } from "react-bootstrap";

export default function MediaGallery() {
  return (
    <Container fluid className="py-5 bg-white" style={{minHeight:"80vh"}}>
      <h2 className="text-center text-primary fw-semibold mt-4">Gallery</h2>
      <Row className="mt-4 g-3 justify-content-center">
        <Col xs={6} md={4} className="d-flex justify-content-center">
          <Image 
            src="/gallery-coming-soon.jpg" 
            alt="Coming Soon" 
            className="w-50 h-auto rounded"
          />
        </Col>
        {/* Uncomment these lines when you have more images */}
        {/* 
        <Col xs={6} md={4}>
          <Image src="/gallery-coming-soon.jpg" alt="Construction Site 2" className="w-100 h-100 object-fit-cover rounded" />
        </Col>
        <Col xs={6} md={4}>
          <Image src="/gallery-coming-soon.jpg" alt="Construction Site 3" className="w-100 h-100 object-fit-cover rounded" />
        </Col>
        <Col xs={6} md={4}>
          <Image src="/gallery-coming-soon.jpg" alt="Construction Site 4" className="w-100 h-100 object-fit-cover rounded" />
        </Col>
        <Col xs={6} md={4}>
          <Image src="/gallery-coming-soon.jpg" alt="Construction Site 5" className="w-100 h-100 object-fit-cover rounded" />
        </Col>
        <Col xs={6} md={4}>
          <Image src="/gallery-coming-soon.jpg" alt="Construction Site 6" className="w-100 h-100 object-fit-cover rounded" />
        </Col>
        */}
      </Row>
    </Container>
  );
}
